<div class="topChildDiv">

    <div style="margin-bottom:2%">

        <div class="text-center headerStyle">{{TransactionMasterHeader}}</div>

        <div style="overflow-y: hidden;" class="formStyle">

            <form novalidate [formGroup]="formValid" class="marginStyle">

                <div class="container">

                    <div style="max-width: 0; max-height: 0; overflow: hidden;">

                        <input autofocus="true" />

                    </div>

                    <div style="display: flex; justify-content: space-evenly">

                    <div class="fieldStyle" *ngFor="let ngModelObjectFourTemporary of ngModelObjectDivision">

                        <div *ngFor = "let ngModelTemporary of ngModelObjectFourTemporary">

                            <div *ngIf="ngModelTemporary.fieldType=='valueDropDown' || ngModelTemporary.fieldType=='valueParentDropDown' ||  ngModelTemporary.fieldType == 'Select List - Static' || ngModelTemporary.fieldType == 'Linked Fields'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="@@Targetstdcode">{{ngModelTemporary.formName}}</mat-label>

                                    <mat-select formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory" (ngModelChange)="childDropDown(ngModelTemporary)">

                                        <mat-option>None</mat-option>

                                        <span *ngFor="let temporaryObject of tMLOD[ngModelTemporary.dropDownIndex]">

                                            <mat-option *ngFor="let tempObject of temporaryObject.keyJson" [value]="tempObject" [disabled]="temporaryObject.status == 'No'">

                                                {{temporaryObject.dropDownValueDisplay}}

                                            </mat-option>

                                        </span>

                                    </mat-select>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueText' || ngModelTemporary.fieldType=='valueEmail' || ngModelTemporary.fieldType=='Email' || ngModelTemporary.fieldType=='Free Text Single line' || ngModelTemporary.fieldType=='Attachment File'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="Targetjointno">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput type="text" formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory" [readonly]="ngModelTemporary.readOnlyValue">

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='DatePicker' || ngModelTemporary.fieldType=='Start & End Date'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="TargetAccountNumber">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [matDatepicker]="i"
                                    [min]="ngModelTemporary.endDateValueMin" [max]="ngModelTemporary.endDateValue" readonly [required]="ngModelTemporary.mandatory">

                                    <mat-datepicker-toggle matSuffix [for]="i">

                                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>

                                    </mat-datepicker-toggle>

                                    <mat-datepicker #i></mat-datepicker>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('matDatepickerParse') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('required') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueDate' || ngModelTemporary.fieldType=='valueStartDate' || ngModelTemporary.fieldType=='valueEndDate'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="TargetAccountNumber">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [matDatepicker]="i"
                                    [min]="ngModelTemporary.startDateValue" [max]="ngModelTemporary.endDateValue" readonly [required]="ngModelTemporary.mandatory" (dateChange)="changeStartEndDateValue(ngModelTemporary)">

                                    <mat-datepicker-toggle matSuffix [for]="i">

                                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>

                                    </mat-datepicker-toggle>

                                    <mat-datepicker #i></mat-datepicker>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('matDatepickerParse') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('required') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='DateTimePicker' || ngModelTemporary.fieldType=='Start & End Date Time'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="TargetDateTime">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput [(ngModel)]="ngModelTemporary.keyValue" [owlDateTimeTrigger]="i"  [owlDateTime]="i" formControlName={{ngModelTemporary.fieldName}} [min]="ngModelTemporary.endDateTimeValueMin" [max]="ngModelTemporary.endDateTimeValue" readonly [required]="ngModelTemporary.mandatory">

                                    <em [owlDateTimeTrigger]="i" class="fas fa-caret-down" style="display: flex; position: absolute; top: 1%; left: 93%;"></em>

                                    <owl-date-time #i></owl-date-time>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('required') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueDateTime' || ngModelTemporary.fieldType=='valueStartDateTime' || ngModelTemporary.fieldType=='valueEndDateTime'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="TargetDateTime">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput [(ngModel)]="ngModelTemporary.keyValue" [owlDateTimeTrigger]="i"  [owlDateTime]="i" formControlName={{ngModelTemporary.fieldName}} [min]="ngModelTemporary.startDateTimeValue" [max]="ngModelTemporary.endDateTimeValue" readonly [required]="ngModelTemporary.mandatory" (dateTimeChange)="changeStartEndDateTimeValue(ngModelTemporary)">

                                    <em [owlDateTimeTrigger]="i" class="fas fa-caret-down" style="display: flex; position: absolute; top: 1%; left: 93%;"></em>

                                    <owl-date-time #i></owl-date-time>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError('required') && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueFilePath' || ngModelTemporary.fieldType=='Attachment'">
                                <div class = "row" style="margin-left:0px;margin-right:0px">

                                    <div class="col-lg-3" style="padding-left:inherit">

                                        <div class="file-field">

                                            <a class="btn-floating  btn-sm m-0">

                                            <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>

                                            <input type="file" (change)="imageFunction($event,ngModelTemporary)" formControlName={{ngModelTemporary.fieldName}}>

                                            </a>

                                        </div>

                                    </div>

                                    <div class="col-lg-7" style="padding-left:0px;padding-right:0px">

                                        <div *ngIf="ngModelTemporary.imageShow" style="width:100%;height:75px;display: inline-block;">

                                            <div *ngIf="ngModelTemporary.imageShow1">

                                                <div class="card" style="width:75%; display: inline-block;margin:0% 1%;height: 100%;">

                                                    <div class="cardButtonDiv">

                                                        <button type="button" class="close badge badge-danger" aria-label="Close" (click)="deleteImage(ngModelTemporary)">

                                                        <em class="fa fa-times" aria-hidden="true" style="font-family: 'Font Awesome 5 Free';font-weight: 900"></em>

                                                        </button>

                                                    </div>

                                                    <!-- Card content -->
                                                    <div class="card-body" style="padding: 2%;overflow: hidden;height: -webkit-fill-available;" (click)="openImage(ngModelTemporary.keyValue)">

                                                        <!-- Card image -->
                                                        <div>

                                                            <img id="expand" class="card-img-top" [src]="getSanitizer(ngModelTemporary.keyValue)" alt="Card Image cap" style="width: 100%;height: 75px;">

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                            <div *ngIf="ngModelTemporary.fileShow">

                                                <div class="card" style="width:100%; display: inline-block;margin:0% 1%;background-color:lightcyan">

                                                    <div class="cardButtonDiv">

                                                        <button type="button" class="close badge badge-danger" aria-label="Close" (click)="deleteImage(ngModelTemporary)">

                                                        <em class="fa fa-times" aria-hidden="true" style="font-family: 'Font Awesome 5 Free';font-weight: 900"></em>

                                                        </button>

                                                    </div>

                                                    <!-- Card content -->
                                                    <div class="card-body" style="padding: 2%;overflow: hidden;height: -webkit-fill-available;">

                                                        <span>{{ngModelTemporary.imageNameDisplay}}</span>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <div class="col-lg-2">

                                        <div *ngIf="ngModelTemporary.downloadIconShow">

                                            <a (click)="docdownload(ngModelTemporary)" style="font-size:1.5rem;color:green"><em class="fas fa-download" title="Download"></em></a>

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valuePassword' || ngModelTemporary.fieldType=='Password'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="Targetjointno">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput [type]="hide ? 'text' : 'password'" formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory">

                                    <mat-icon matSuffix *ngIf="eyeIcon" (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}
                                    </mat-icon>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueInteger' || ngModelTemporary.fieldType=='Integer Number'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="Targetjointno">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput type="text" formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory">

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueDecimal' || ngModelTemporary.fieldType=='Decimal Number'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="TargetNumberNumeric">{{ngModelTemporary.formName}}</mat-label>

                                    <input matInput type="text" formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory" [readonly]="ngModelTemporary.readOnlyValue">

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueCheckbox' || ngModelTemporary.fieldType=='Checkbox'">

                                <mat-checkbox formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory">{{ngModelTemporary.formName}}</mat-checkbox>

                                <mat-error style="font-size:75%;font-weight:normal" *ngFor="let validation of ngModelTemporary.validationMessages">

                                    <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                        {{ validation.message }}

                                    </span>

                                </mat-error>

                            </div>
                            <div *ngIf="ngModelTemporary.fieldType=='valueRadio' || ngModelTemporary.fieldType=='Radio'" appearance="outline">
                            <div  style="display: flex;margin-top: 7px;">
                                <label style="padding: 0px 5px;font-size: 14px;">{{ngModelTemporary.formName}} : </label>
                                <mat-radio-group style="display: grid;margin-top: -1px;"  formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory">
                                <mat-radio-button style="padding: 0px 5px;" *ngFor = "let eachradiovalue of ngModelTemporary.radio" [value]="eachradiovalue" (change)="radiochange($event)">{{eachradiovalue}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <mat-error style="    font-size: 75%;
                        font-weight: normal;" *ngFor="let validation of ngModelTemporary.validationMessages">

                            <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                {{ validation.message }}

                            </span>

                        </mat-error>

                            </div>

                            <div *ngIf="ngModelTemporary.fieldType=='valueTextArea' || ngModelTemporary.fieldType=='Free Text Multi line'">

                                <mat-form-field appearance="outline">

                                    <mat-label i18n="Targetjointno">{{ngModelTemporary.formName}}</mat-label>

                                    <textarea matInput type="text" formControlName={{ngModelTemporary.fieldName}} [(ngModel)]="ngModelTemporary.keyValue" [required]="ngModelTemporary.mandatory">{{ngModelTemporary.keyValue}}</textarea>

                                    <mat-error *ngFor="let validation of ngModelTemporary.validationMessages">

                                        <span *ngIf="formValid.get(ngModelTemporary.fieldName).hasError(validation.type) && (formValid.get(ngModelTemporary.fieldName).dirty || formValid.get(ngModelTemporary.fieldName).touched)">

                                            {{ validation.message }}

                                        </span>

                                    </mat-error>

                                </mat-form-field>

                            </div>

                        </div>

                    </div>

                    </div>

                </div>

            </form>

        </div>

    </div>

    <div class="text-right updateStyle">

        <button i18n="@@UpdateData" type="button" (click)="updateData()"
        class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
            >Update</button>

    </div>

    <div class="text-center headerStyle">{{TransactionDetailHeader}}</div>

    <div class="agGridOuterDiv">
<div>
    <mat-toolbar class="agGridpopupOuterDiv card" style="
    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
border-right: 1px solid #a9a9a9a8;
border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" class="textColour">{{headerNameHtml}}</label>

                <span class="example-spacer"></span>
                <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" title="Add Record" [style.background-color]="backgroundColorButton" (click) = "openSaveForm('Save')">Add Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>

                </button>
                <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" title="Download" [style.background-color]="backgroundColorButton" (click) = "onBtExport()">Download
                        <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                </button>
                 <div class="insertPageNoDiv">
                    <mat-form-field appearance="outline">
                        <mat-label i18n="@@Targetpageno">Page No</mat-label>
                        <input matInput type="text" (input)="onSearchChange($event.target.value)">
                    </mat-form-field>
                </div>
                <div class="selectRecordsDiv" style="width:9.5%">
                    <mat-form-field appearance="outline" style="width:100%">
                        <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                        <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged(value)">
                            <mat-option value="10" selected>10</mat-option>
                            <mat-option value="200">200</mat-option>
                            <mat-option value="300">300</mat-option>
                            <mat-option value="400">400</mat-option>
                        </mat-select>

                    </mat-form-field>
                </div>
                <div class="card pagination paginationFirstButton paginationFirstlastButton">
                    <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                </div>
                <div class="card pagination paginationButtons btn-rounded">
                    <ul>
                        <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                (click)="onBtPrevious()"></em></li>
                        <li>{{currentPage}}/{{totalPages}}</li>
                        <li class="paginationliicon" style="padding:0;"><em
                                class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                    </ul>
                </div>
                <div class="card pagination paginationLastButton paginationFirstlastButton">
                    <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                </div>

    </mat-toolbar>
</div>
<div *ngIf="agGridChildShow">
<ag-grid-angular class="ag-theme-balham table-child-width tablestyles square scroolbar-dusty-grass square thin"
[columnDefs]="columnChildDefs" [animateRows]="true" [pagination]="true"
[rowSelection]="rowSelection" [defaultColDef]="defaultChildColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
[headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
[enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
(paginationChanged)="onPaginationChanged()" [components]="components"
(gridReady)="onGridChildReady($event)" [hidden]="!true"></ag-grid-angular>

</div>

</div>
</div>
<div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">

<div class="col-lg text-center">



<button i18n="@@TargetCancel" type="button" (click)="cancel()"
class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
 [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>

</div>

</div>
